import React from 'react'
import { css } from 'aphrodite'
import { Col, Row } from 'reactstrap'

import style from '../style'

export const GameBox = props => (
  <Row>
    <Col md='2'>
      <img
        src={props.image.url}
        alt={props.image.alt}
        className={css(style.gamebox.image)}
      />
    </Col>
    <Col md='10'>
      <h3 className={css(style.gamebox.title)}>{props.title}</h3>
      <div className={css(style.gamebox.infoBox)}>
        <span className={css(style.gamebox.infoLabel)}>Release Date:</span>
        <span className={css(style.gamebox.infoValue)}>{props.dateStr}</span>
      </div>
      <p
        className={css(style.gamebox.p)}
        dangerouslySetInnerHTML={{ __html: props.description }}
      />
    </Col>
  </Row>
)

export default GameBox



// WEBPACK FOOTER //
// ./src/components/Games/partials/gamebox.js